export function formatNumberWithCommas(value) {
    if (!isNaN(value) && typeof value === "number") {
        return value.toLocaleString();
    }
    return 0;
}
